/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_S5Inputs */

const en_tut_rapat_s5 = /** @type {(inputs: Tut_Rapat_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write decisions in the **Catatan** tab and press **Simpan catatan**. **Simpan sebagai dokumen** copies them into a document of their own, which does not disappear with the transcript.`)
};

const id_tut_rapat_s5 = /** @type {(inputs: Tut_Rapat_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulis keputusan di tab **Catatan**, tekan **Simpan catatan**. **Simpan sebagai dokumen** menyalinnya menjadi dokumen tersendiri yang tidak ikut terhapus bersama transkrip.`)
};

/**
* | output |
* | --- |
* | "Write decisions in the **Catatan** tab and press **Simpan catatan**. **Simpan sebagai dokumen** copies them into a document of their own, which does not disa..." |
*
* @param {Tut_Rapat_S5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_s5 = /** @type {((inputs?: Tut_Rapat_S5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_S5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_s5(inputs)
	return en_tut_rapat_s5(inputs)
});